import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {BaseRepository} from "./base/base.repository";

@Injectable({
    providedIn: 'root'
})
export class PlaceRepository extends BaseRepository {
    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.path = 'dashboard/admin/places';
    }

    attachPlaceToRestaurantHistory(restaurantHistoryId: number, placeId: number) {
        const path = 'dashboard/admin/restaurant-histories/' + restaurantHistoryId.toString() + '/places/' + placeId.toString();
        return super.patch(path);
    }

    getAllPlaceForRestaurantHistory(restaurantHistoryId: number) {
        const path = 'dashboard/admin/restaurant-histories/places/' + restaurantHistoryId.toString();
        return super.get(path);
    }

}

